import { ConfigurationType } from './consts';
import { Party, PartyRole } from './party.domain';
import { InsuredProduct, InsuredProductMotor } from './product.domain';

export interface SalespointDocument {
    id: number;
    number: string;
    partyList: Party[];
    partyRoleList: PartyRole[];
    additionalData: DocumentAdditionalData;
    productList: InsuredProduct[];
}

export function enrichParties(salespointDocument: SalespointDocument) {
    for (let i = 0; i < salespointDocument.productList.length; i++) {
        const product = salespointDocument.productList[i];
        if (product.configuration.configurationType === ConfigurationType.MOTOR) {
            enrichPartiesProduct(salespointDocument, product as InsuredProductMotor);
        }
    }
}

export function enrichPartiesProduct(salespointDocument: SalespointDocument, product: InsuredProductMotor) {
    product.parties = salespointDocument.partyList.reduce((map, party) => {
        map[party.id] = party;
        return map;
    }, {});
}

export class DocumentAdditionalData {
    clauseMap: { [param: string]: boolean }
    contactData: ContactData;
    hasContactData: boolean;
    location: string;
}

export class ContactData {
    phonePrefix: string = '+380';
    phoneNumber: string = null;
    email: string = null;
}

export class EmailData {
    email: string;
    clause: boolean;
}
